import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { SxProps, Theme } from "@mui/material/styles";

export interface CheckBoxProps {
  readonly required?: boolean;
  readonly disabled?: boolean;
  readonly label?: string;
  readonly labelPlacement?: "bottom" | "end" | "start" | "top";
  readonly onChange?: () => void;
  readonly sx?: SxProps<Theme>;
  readonly state?: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}
export default function CheckBox(props?: CheckBoxProps) {
  const checked = props?.state ? props.state[0] : undefined;
  const setChecked = props?.state ? props.state[1] : undefined;
  const onChange = setChecked
    ? () => {
        setChecked(!checked);
      }
    : undefined;
  return (
    <FormGroup>
      <FormControlLabel
        sx={props?.sx}
        required={props?.required}
        disabled={props?.disabled}
        control={<Checkbox checked={checked} onChange={onChange} />}
        label={props?.label}
      />
    </FormGroup>
  );
}
